export default {
  new_schedule: "Cadastrar agenda",
  update_schedule: "Atualizar agenda",
  search_schedule: "Buscar por agenda",
  no_vacancy: "Nenhuma vaga encontrada",
  not_find_schdules_vacancies:
    "Não encontramos nenhuma vaga correspondete aos dados da solicitação",
};
